<div #top class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div
                        [ngClass]="!isMobileXL() ? 'd-flex justify-content-between' : 'd-flex flex-column justify-content-center align-items-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>

                        <button mat-flat-button color="accent" (click)="regresarALaRutaAnterior()">
                            <mat-icon>arrow_left</mat-icon>
                            Volver al buscador</button>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div #cotizacion class="container-custom-content animate__animated animate__fadeIn  buscador-pedidos">

    <mat-accordion multi>

        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Datos del pedido
                </mat-panel-title>
            </mat-expansion-panel-header>
            <form id="contenido" [formGroup]="cabForm">
                <div class="container-fluid mt-4">

                    <div class="row">

                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaCreacion}}</mat-label>

                                <input readonly [value]="cabForm.controls['fechaCreacion'].value | date:'dd/MM/yyyy'"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>


                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TipoOrden}}</mat-label>

                                <input readonly formControlName="tipoOrden" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">

                        <!-- <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOrdenSAP}}</mat-label>

                                <input readonly formControlName="nroOrdenSAP" type="text" matInput>
                            </mat-form-field>
                        </div> -->

                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroCotizacion}}</mat-label>

                                <input readonly formControlName="nroPedido" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div *ngIf="idTipo != 1" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaEntrega}}</mat-label>
                                <input readonly matInput [matDatepicker]="picker" formControlName="fechaEntrega">
                                <mat-datepicker-toggle [disabled]="cabForm.controls['idEstado'].value != 1" matSuffix
                                    [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-card class="mat-card-estado estadoCotizacion_{{cabForm.get('idEstado').value}}">
                                <mat-card-content>{{cabForm.get('estado').value}}</mat-card-content>
                            </mat-card>
                        </div>

                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                        <mat-divider>
                        </mat-divider>
                    </div>

                    <!-- <div class="row">

                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Division}}</mat-label>
                                <mat-select (selectionChange)='seleccionarDivision($event.value)'
                                    [compareWith]="compareDivisiones" formControlName="idDivision">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of divisiones" [value]="d.id">{{d.displayValue}}
                                    </mat-option>
                                </mat-select>

                                <mat-error
                                    *ngIf="(cabForm.get('idDivision').hasError('required')) && cabForm.get('idDivision').touched">
                                    {{Validaciones.IdDivision}}
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="divisionSeleccionada != null && (dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Division}}</mat-label>
                                <input readonly [value]="divisionSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>
                    </div> -->
                    <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                            <mat-divider>
                            </mat-divider>
                        </div> -->
                    <div class="row">
                        <div *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Cliente}}</mat-label>
                                <input (change)="handleEmptyInputCliente($event)" matInput [matAutocomplete]="autoC"
                                    [formControl]="fcAutocompleteCliente" placeholder="Nro. cliente, nombre, etc...">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="Limpiar cliente seleccionado" (click)="limpiarCliente(true)">

                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoC="matAutocomplete"
                                    (optionSelected)='seleccionarCliente($event.option.value,null,null,null,null,null)'
                                    [displayWith]="getOptionTextCliente">
                                    <mat-option *ngIf="loadingFcAutocompleteCliente"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteCliente">
                                        <mat-option *ngFor="let cl of clientesEncontrados" [value]="cl">
                                            {{cl.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>


                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3"
                            *ngIf="this.mensajeCreditoExcedido && cabForm.controls['idEstado'].value == 1">

                            <mat-card [ngClass]="{
                                    'mat-card-aviso-credito': this.credito >= 0,
                                    'mat-card-aviso-credito-excedido': this.credito < 0
                                }" class="animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeCreditoExcedido}}</p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3"
                            *ngIf="this.mensajeDeudaVencida && cabForm.controls['idEstado'].value == 1">

                            <mat-card
                                class="mat-card-aviso-deuda-vencida animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeDeudaVencida}}</p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroCliente}}</mat-label>
                                <input readonly formControlName="nroCliente" type="text" matInput>
                                <mat-error
                                    *ngIf="(cabForm.get('nroCliente').hasError('required')) && cabForm.get('nroCliente').touched">
                                    {{Validaciones.Cliente}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NombreCliente}}</mat-label>
                                <input readonly formControlName="nombreCliente" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CuitCliente}}</mat-label>
                                <input readonly formControlName="cuit" type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <!-- <mat-form-field color="accent-darker" appearance="outline"
                                *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1">
                                <mat-label>{{Etiquetas.IdGrupoCliente}}</mat-label>
                                <mat-select (selectionChange)='seleccionarGC($event.value)' [compareWith]="compareGC"
                                    formControlName="idGrupoCliente">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let gc of gcs" [value]="gc.id">{{gc.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(cabForm.get('idGrupoCliente').hasError('required')) && cabForm.get('idGrupoCliente').touched">
                                    {{Validaciones.IdGrupoCliente}}
                                </mat-error>
                            </mat-form-field> -->
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="gcSeleccionado != null && (dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.IdGrupoCliente}}</mat-label>
                                <input readonly [value]="gcSeleccionado.displayValue" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field [class.readonly-form-field]="cabForm.get('idEstado').value > 2 || !alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Email}}</mat-label>
                                <input (change)="cambioEmail($event)" formControlName="email" type="email" matInput
                                    [readonly]="cabForm.get('idEstado').value > 2 || !alta">
                                <mat-error *ngIf="cabForm.get('email').errors?.email && cabForm.get('email').touched">
                                    El correo electrónico no es válido.
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field [class.readonly-form-field]="cabForm.get('idEstado').value > 2 || !alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.EmailOpcional}}</mat-label>
                                <input (change)="cambioEmailOpcional($event)" formControlName="emailOpcional"
                                    type="email" matInput [readonly]="cabForm.get('idEstado').value > 2 || !alta">
                                <mat-error
                                    *ngIf="cabForm.get('emailOpcional').errors?.email && cabForm.get('emailOpcional').touched">
                                    El correo electrónico no es válido.
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>
                    <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                        <mat-divider>
                        </mat-divider>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                            <mat-form-field
                                *ngIf="!isInRole('VENDEDOR') && !dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.ZonaVendedor}}</mat-label>
                                <input (change)="handleEmptyInputVendedor($event)" matInput [matAutocomplete]="autoZV"
                                    [formControl]="fcAutocompleteZv" placeholder="Id, nombre, etc..">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="Limpiar vendedor seleccionado" (click)="limpiarVendedor(true)">

                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoZV="matAutocomplete"
                                    (optionSelected)='seleccionarZonaVendedor($event.option.value)'
                                    [displayWith]="getOptionTextZV">
                                    <mat-option *ngIf="loadingFcAutocompleteZV"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteZV">
                                        <mat-option *ngFor="let zv of zvsEncontradas" [value]="zv">
                                            {{zv.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="!isInRole('VENDEDOR')" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.ZonaVendedorSeleccionada}}</mat-label>
                                <input *ngIf="zvSeleccionada == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="zvSeleccionada != null" readonly [value]="zvSeleccionada.displayValue"
                                    type="text" matInput>
                                <mat-error
                                    *ngIf="(cabForm.get('idZonaVendedor').hasError('required')) && cabForm.get('idZonaVendedor').touched">
                                    {{Validaciones.ZonaVendedor}}
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div *ngIf="!isInRole('VENDEDOR')" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!isInRole('VENDEDOR') && !dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Region}}</mat-label>
                                <mat-select (selectionChange)='seleccionarRegion($event.value)'
                                    [compareWith]="compareRegiones" formControlName="idRegion">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let r of regiones" [value]="r.id">{{r.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(cabForm.get('idRegion').hasError('required')) && cabForm.get('idRegion').touched">
                                    {{Validaciones.IdRegion}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="regionSeleccionada != null && (isInRole('VENDEDOR') || dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Region}}</mat-label>
                                <input readonly [value]="regionSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>

                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <mat-form-field *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                            color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.DireccionEntrega}}</mat-label>
                            <mat-select (selectionChange)='seleccionarDirEntrega($event.value)'
                                [compareWith]="compareDireccionEntrega" formControlName="nroClienteDireccionEntrega">
                                <mat-option [value]="">- Seleccione -</mat-option>
                                <mat-option *ngFor="let de of dirEntregas" [value]="de.nroCliente">{{de.displayValue}}
                                </mat-option>
                            </mat-select>

                            <mat-error
                                *ngIf="(cabForm.get('nroClienteDireccionEntrega').hasError('required')) && cabForm.get('nroClienteDireccionEntrega').touched">
                                {{Validaciones.DireccionEntrega}}
                            </mat-error>
                        </mat-form-field>

                    </div>

                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="dirEntregaSeleccionada != null">
                                <mat-label>{{Etiquetas.NroClienteDireccionEntrega}}</mat-label>

                                <input readonly [value]="dirEntregaSeleccionada.nroCliente" type="text" matInput>

                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="dirEntregaSeleccionada == null">
                                <mat-label>{{Etiquetas.NroClienteDireccionEntrega}}</mat-label>

                                <input readonly [value]="" type="text" matInput>

                            </mat-form-field>
                        </div>
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NombreClienteDireccionEntrega}}</mat-label>

                                <input readonly formControlName="nombreClienteDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CiudadDireccionEntrega}}</mat-label>

                                <input readonly formControlName="ciudadDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div *ngIf="idTipo != 1 || dataSourceItems.data.length"
                            class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CalleNroDireccionEntrega}}</mat-label>

                                <input readonly formControlName="calleNroDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CuentaDistribuidor}}</mat-label>
                                <mat-select [compareWith]="compareCuentasDistribuidores"
                                    formControlName="nroClienteDistribuidor"
                                    (selectionChange)='seleccionarCuentaDistribuidor($event.value,null)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of cuentasDistribuidores"
                                        [value]="d.nroClienteDistribuidor">{{d.nombre}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(cabForm.get('nroClienteDistribuidor').hasError('required')) && cabForm.get('nroClienteDistribuidor').touched">
                                    {{Validaciones.NroClienteDistribuidor}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="ctaDistrubuidorSeleccionada != null && (dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.CuentaDistribuidor}}</mat-label>
                                <input readonly [value]="ctaDistrubuidorSeleccionada.nombre" type="text" matInput>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Direccion}}</mat-label>
                                <mat-select [compareWith]="compareDirecciones" formControlName="idSucursal"
                                    (selectionChange)='seleccionarDireccion($event.value)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of direcciones" [value]="d.nroCliente">
                                        {{d.displayValue2}}
                                        <!-- {{d.ciudad}} - {{d.calleNro}} -->
                                    </mat-option>
                                </mat-select>

                                <mat-error
                                    *ngIf="(cabForm.get('idSucursal').hasError('required')) && cabForm.get('idSucursal').touched">
                                    {{Validaciones.IdSucursal}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="direccionSeleccionada != null && (dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Direccion}}</mat-label>
                                <input readonly [value]="direccionSeleccionada.displayValue2" type="text" matInput>

                            </mat-form-field>
                        </div>
                    </div>
                    <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                        <mat-divider>
                        </mat-divider>
                    </div> -->

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field *ngIf="cabForm.controls['idEstado'].value == 1" color="accent-darker"
                                appearance="outline">
                                <mat-label>{{Etiquetas.Glosa}}</mat-label>

                                <input #glosa matInput maxlength="300" formControlName="glosa" type="text" matInput>

                                <mat-hint align="start">Máximo: 300
                                    caracteres</mat-hint>
                                <mat-hint align="end">{{glosa.value?.length || 0}} / 300</mat-hint>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" *ngIf="cabForm.controls['idEstado'].value != 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Glosa}}</mat-label>

                                <input #glosa matInput maxlength="300" readonly formControlName="glosa" type="text"
                                    matInput>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOC}}</mat-label>

                                <input matInput formControlName="nroOC" type="text">

                            </mat-form-field>
                            <mat-form-field class="readonly-form-field"
                                *ngIf="dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOC}}</mat-label>
                                <input readonly formControlName="nroOC" type="text" matInput>

                            </mat-form-field>

                        </div>
                    </div>


                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                        <mat-divider>
                        </mat-divider>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TipoListaPrecios}}</mat-label>
                                <mat-select [compareWith]="compareLPs" formControlName="idTipoListaPrecios"
                                    (selectionChange)='seleccionarLP($event.value, null)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let lp of lps" [value]="lp.id">
                                        {{lp.displayValue}}
                                    </mat-option>
                                </mat-select>

                                <mat-error
                                    *ngIf="(cabForm.get('idTipoListaPrecios').hasError('required')) && cabForm.get('idTipoListaPrecios').touched">
                                    {{Validaciones.ListaPrecios}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="lpSeleccionada != null && (dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.TipoListaPrecios}}</mat-label>
                                <input readonly [value]="lpSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="cabForm.controls['idEstado'].value == 1 && !dataSourceItems.data.length"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TerminoPago}}</mat-label>
                                <mat-select [compareWith]="compareTerminosPago" formControlName="idTerminoPago"
                                    (selectionChange)='seleccionarTP($event.value)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let t of terminosPago" [value]="t.id">{{t.descripcion}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(cabForm.get('idTerminoPago').hasError('required')) && cabForm.get('idTerminoPago').touched">
                                    {{Validaciones.IdTerminoPago}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="tpSeleccionado != null && (dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.TerminoPago}}</mat-label>
                                <input readonly [value]=" tpSeleccionado.descripcion" type="text" matInput>

                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaPrecio}}</mat-label>
                                <input readonly matInput [matDatepicker]="picker" formControlName="fechaPrecio"
                                    [min]="minDate">

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>

                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1">
                                <mat-label>{{Etiquetas.FechaPrecio}}</mat-label>

                                <input readonly [value]="cabForm.controls['fechaPrecio'].value | date:'dd/MM/yyyy'"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!isInRole('VENDEDOR') && !dataSourceItems.data.length && cabForm.controls['idEstado'].value == 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Planta}}</mat-label>
                                <mat-select (selectionChange)='seleccionarPlanta($event.value)'
                                    [compareWith]="comparePlantas" formControlName="idPlanta">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let p of plantas" [value]="p.idPlanta">{{p.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(cabForm.get('idPlanta').hasError('required')) && cabForm.get('idPlanta').touched">
                                    {{Validaciones.IdPlanta}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="!isInRole('VENDEDOR') && plantaSeleccionada != null && (dataSourceItems.data.length || cabForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Planta}}</mat-label>
                                <input readonly [value]="plantaSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>

                    </div>

                </div>



            </form>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Ítems del pedido
                </mat-panel-title>


            </mat-expansion-panel-header>
            <!-- <div class="mat-table-pedidos"> -->
            <form [formGroup]="itemForm">
                <div class="container-fluid mt-4">

                    <div class="row align-items-center" *ngIf="cabForm.controls['idEstado'].value == 1 && alta">

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="!isInRole('VENDEDOR')">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Planta}}</mat-label>
                                <mat-select (selectionChange)='seleccionarPlantaItem($event.value)'
                                    [compareWith]="comparePlantas" formControlName="idPlanta">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let p of plantasItem" [value]="p.idPlanta">{{p.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(itemForm.get('idPlanta').hasError('required')) && itemForm.get('idPlanta').touched">
                                    {{Validaciones.IdPlanta}}
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="!isInRole('VENDEDOR')">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.StorageLocation}}</mat-label>
                                <mat-select (selectionChange)='seleccionarStorageLocation($event.value)'
                                    [compareWith]="compareStoragesLocations"
                                    formControlName="idUbicacionAlmacenamiento">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let sl of storagesLocations" [value]="sl.id">{{sl.id}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(itemForm.get('idUbicacionAlmacenamiento').hasError('required')) && itemForm.get('idUbicacionAlmacenamiento').touched">
                                    {{Validaciones.StorageLocation}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Item}}</mat-label>
                                <input (change)="handleEmptyInputItem($event)" matInput [matAutocomplete]="autoItem"
                                    [formControl]="fcAutocompleteItem" placeholder="Código, descripción, etc..">
                                <button type="button" matSuffix mat-icon-button (click)="limpiarItem(true)"
                                    matTooltip="Limpiar ítem seleccionado">
                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoItem="matAutocomplete"
                                    (optionSelected)='seleccionarItem($event.option.value)'
                                    [displayWith]="getOptionTextItem">
                                    <mat-option *ngIf="loadingFcAutocompleteItem"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteItem">
                                        <mat-option *ngFor="let i of itemsEncontrados" [value]="i">
                                            {{i.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>

                        <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.PrecioUnitarioLista}}</mat-label>
                                <input *ngIf="itemSeleccionado == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="itemSeleccionado != null" readonly
                                    [value]="itemSeleccionado.tasa | number : '1.2-2'" type="text" matInput>
                            </mat-form-field>
                        </div> -->

                        <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                                <input *ngIf="itemSeleccionado == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="itemSeleccionado != null" readonly [value]="itemSeleccionado.idProducto"
                                    type="text" matInput>
                            </mat-form-field>
                        </div> -->

                        <!-- 
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Producto}}</mat-label>
                                <input *ngIf="itemSeleccionado == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="itemSeleccionado != null" readonly [value]="itemSeleccionado.producto"
                                    type="text" matInput>
                            </mat-form-field>
                        </div> -->



                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
                            <mat-divider>
                            </mat-divider>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
                            <div
                                [ngClass]="!isMobileXL() ? 'd-flex justify-content-between' : 'd-flex flex-column justify-content-center align-items-center'">
                                <p class="mat-card-header-titulo">
                                    Distribuidor
                                    <span *ngIf="direccionSeleccionada" style="font-size: 1.2rem;"> {{
                                        direccionSeleccionada.nombre}} - {{ direccionSeleccionada.ciudad }} </span>
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label *ngIf="direccionSeleccionada != null">{{Etiquetas.CantidadDisponible}}
                                    <!-- (Sucursal {{direccionSeleccionada.displayValue}}) -->
                                </mat-label>
                                <input readonly
                                    [value]="itemForm.controls['cantDispDistribuidor'].value | number : '1.3-3'"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>
                                    <!-- {{Etiquetas.Cantidad}} -->
                                    Cantidad
                                </mat-label>
                                <input appThreeDigitDecimaNumber formControlName="cantidadDistribuidor"
                                    (focusout)="checkCantidad('cantidadDistribuidor')" type="text" matInput>
                                <mat-error
                                    *ngIf="!itemForm.controls['cantidadDistribuidor'].valid && itemForm.get('cantidadDistribuidor').touched">
                                    {{Validaciones.Cantidad}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div id="avisoUnidadesPalletDistribuidor" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                            *ngIf="avisoUnidadesPalletDistribuidor">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeUnidadesPalletDistribuidor}} </p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                        <!-- <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CantidadDisponibleCuota}}
                                    {{mesAnioPrimerCuotaDistribuidor}}</mat-label>
                                <input readonly
                                    [value]="itemForm.controls['cantDispDistribuidorPrimerCuota'].value | number : '1.3-3'"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaEntrega}}</mat-label>
                                <input readonly matInput [matDatepicker]="picker"
                                    formControlName="fechaPrimerCuotaDistribuidor"
                                    [min]="minDateFechaEntregaPrimerCuota">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error
                                    *ngIf="(itemForm.get('fechaPrimerCuotaDistribuidor').hasError('required')) && itemForm.get('fechaPrimerCuotaDistribuidor').touched">
                                    {{Validaciones.FechaEntrega}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CantidadProgramada}}</mat-label>
                                <input appThreeDigitDecimaNumber
                                    (focusout)="checkCantidad('cantDistribuidorPrimerCuota')"
                                    formControlName="cantDistribuidorPrimerCuota" type="text" matInput>
                                <mat-error
                                    *ngIf="!itemForm.controls['cantDistribuidorPrimerCuota'].valid && itemForm.get('cantDistribuidorPrimerCuota').touched">
                                    {{Validaciones.Cantidad}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div id="avisoUnidadesPalletDistribuidorPrimerCuota"
                            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                            *ngIf="avisoUnidadesPalletDistribuidorPrimerCuota">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeUnidadesPalletDistribuidorPrimerCuota}} </p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CantidadDisponibleCuota}}
                                    {{mesAnioSegundaCuotaDistribuidor}}</mat-label>
                                <input readonly
                                    [value]="itemForm.controls['cantDispDistribuidorSegundaCuota'].value | number : '1.3-3'"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaEntrega}}</mat-label>
                                <input readonly matInput [matDatepicker]="picker2"
                                    formControlName="fechaSegundaCuotaDistribuidor"
                                    [min]="minDateFechaEntregaSegundaCuota">
                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                                <mat-error
                                    *ngIf="(itemForm.get('fechaSegundaCuotaDistribuidor').hasError('required')) && itemForm.get('fechaSegundaCuotaDistribuidor').touched">
                                    {{Validaciones.FechaEntrega}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CantidadProgramada}}</mat-label>
                                <input appThreeDigitDecimaNumber
                                    (focusout)="checkCantidad('cantDistribuidorSegundaCuota')"
                                    formControlName="cantDistribuidorSegundaCuota" type="text" matInput>
                                <mat-error
                                    *ngIf="!itemForm.controls['cantDistribuidorSegundaCuota'].valid && itemForm.get('cantDistribuidorSegundaCuota').touched">
                                    {{Validaciones.Cantidad}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div id="avisoUnidadesPalletDistribuidorSegundaCuota"
                            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                            *ngIf="avisoUnidadesPalletDistribuidorSegundaCuota">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeUnidadesPalletDistribuidorSegundaCuota}} </p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CantidadDisponibleCuota}}
                                    {{mesAnioTercerCuotaDistribuidor}}</mat-label>
                                <input readonly
                                    [value]="itemForm.controls['cantDispDistribuidorTercerCuota'].value | number : '1.3-3'"
                                    type="text" matInput>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaEntrega}}</mat-label>
                                <input readonly matInput [matDatepicker]="picker3"
                                    formControlName="fechaTercerCuotaDistribuidor"
                                    [min]="minDateFechaEntregaTercerCuota">
                                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                <mat-datepicker #picker3></mat-datepicker>
                                <mat-error
                                    *ngIf="(itemForm.get('fechaTercerCuotaDistribuidor').hasError('required')) && itemForm.get('fechaTercerCuotaDistribuidor').touched">
                                    {{Validaciones.FechaEntrega}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CantidadProgramada}}</mat-label>
                                <input appThreeDigitDecimaNumber
                                    (focusout)="checkCantidad('cantDistribuidorTercerCuota')"
                                    formControlName="cantDistribuidorTercerCuota" type="text" matInput>
                                <mat-error
                                    *ngIf="!itemForm.controls['cantDistribuidorTercerCuota'].valid && itemForm.get('cantDistribuidorTercerCuota').touched">
                                    {{Validaciones.Cantidad}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div id="avisoUnidadesPalletDistribuidorTercerCuota"
                            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                            *ngIf="avisoUnidadesPalletDistribuidorTercerCuota">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeUnidadesPalletDistribuidorTercerCuota}} </p>

                                </mat-card-content>

                            </mat-card>
                        </div> -->
                        <div *ngIf="!isInRole('VENDEDOR')">

                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
                                <div
                                    [ngClass]="!isMobileXL() ? 'd-flex justify-content-between' : 'd-flex flex-column justify-content-center align-items-center'">
                                    <p class="mat-card-header-titulo">
                                        Stock Planta</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <!-- <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CantidadDisponible}} (Sucursal)</mat-label>
                                <input readonly
                                    [value]="itemForm.controls['cantidadDisponibleSucursal'].value | number:'':'es-AR'"
                                    type="text" matInput>

                                </mat-form-field> -->
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <mat-form-field color="accent-darker" appearance="outline">
                                        <mat-label>
                                            <!-- {{Etiquetas.Cantidad}} -->
                                            Cantidad

                                        </mat-label>
                                        <input appThreeDigitDecimaNumber (focusout)="checkCantidad('cantidadPlanta')"
                                            formControlName="cantidadPlanta" type="text" matInput>

                                    </mat-form-field>
                                </div>
                            </div>
                            <div id="avisoUnidadesPalletPlanta" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                                *ngIf="avisoUnidadesPalletPlanta">

                                <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                    <mat-card-content>

                                        <p>{{this.mensajeUnidadesPalletPlanta}} </p>

                                    </mat-card-content>

                                </mat-card>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <mat-form-field class="readonly-form-field" color="accent-darker"
                                        appearance="outline">
                                        <mat-label>{{Etiquetas.CantidadDisponibleCuota}}
                                            {{mesAnioPrimerCuotaPlanta}}</mat-label>
                                        <input readonly
                                            [value]="itemForm.controls['cantDispPlantaPrimerCuota'].value | number : '1.3-3'"
                                            type="text" matInput>

                                    </mat-form-field>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <mat-form-field color="accent-darker" appearance="outline">
                                        <mat-label>{{Etiquetas.CantidadProgramada}}</mat-label>
                                        <input appThreeDigitDecimaNumber
                                            (focusout)="checkCantidad('cantPlantaPrimerCuota')"
                                            formControlName="cantPlantaPrimerCuota" type="text" matInput>
                                        <mat-error
                                            *ngIf="!itemForm.controls['cantPlantaPrimerCuota'].valid && itemForm.get('cantPlantaPrimerCuota').touched">
                                            {{Validaciones.Cantidad}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div id="avisoUnidadesPalletPlantaPrimerCuota"
                                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                                *ngIf="avisoUnidadesPalletPlantaPrimerCuota">

                                <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                    <mat-card-content>

                                        <p>{{this.mensajeUnidadesPalletPlantaPrimerCuota}} </p>

                                    </mat-card-content>

                                </mat-card>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <mat-form-field class="readonly-form-field" color="accent-darker"
                                        appearance="outline">
                                        <mat-label>{{Etiquetas.CantidadDisponibleCuota}}
                                            {{mesAnioSegundaCuotaPlanta}}</mat-label>
                                        <input readonly
                                            [value]="itemForm.controls['cantDispPlantaSegundaCuota'].value | number : '1.3-3'"
                                            type="text" matInput>

                                    </mat-form-field>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <mat-form-field color="accent-darker" appearance="outline">
                                        <mat-label>{{Etiquetas.CantidadProgramada}}</mat-label>
                                        <input appThreeDigitDecimaNumber
                                            (focusout)="checkCantidad('cantPlantaSegundaCuota')"
                                            formControlName="cantPlantaSegundaCuota" type="text" matInput>
                                        <mat-error
                                            *ngIf="!itemForm.controls['cantPlantaSegundaCuota'].valid && itemForm.get('cantPlantaSegundaCuota').touched">
                                            {{Validaciones.Cantidad}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div id="avisoUnidadesPalletPlantaSegundaCuota"
                                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                                *ngIf="avisoUnidadesPalletPlantaSegundaCuota">

                                <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                    <mat-card-content>

                                        <p>{{this.mensajeUnidadesPalletPlantaSegundaCuota}} </p>

                                    </mat-card-content>

                                </mat-card>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <mat-form-field class="readonly-form-field" color="accent-darker"
                                        appearance="outline">
                                        <mat-label>{{Etiquetas.CantidadDisponibleCuota}}
                                            {{mesAnioTercerCuotaPlanta}}</mat-label>
                                        <input readonly
                                            [value]="itemForm.controls['cantDispPlantaTercerCuota'].value | number : '1.3-3'"
                                            type="text" matInput>

                                    </mat-form-field>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <mat-form-field color="accent-darker" appearance="outline">
                                        <mat-label>{{Etiquetas.CantidadProgramada}}</mat-label>
                                        <input appThreeDigitDecimaNumber
                                            (focusout)="checkCantidad('cantPlantaTercerCuota')"
                                            formControlName="cantPlantaTercerCuota" type="text" matInput>
                                        <mat-error
                                            *ngIf="!itemForm.controls['cantDispPlantaTercerCuota'].valid && itemForm.get('cantDispPlantaTercerCuota').touched">
                                            {{Validaciones.Cantidad}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div id="avisoUnidadesPalletPlantaTercerCuota"
                                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                                *ngIf="avisoUnidadesPalletPlantaTercerCuota">

                                <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                    <mat-card-content>

                                        <p>{{this.mensajeUnidadesPalletPlantaTercerCuota}} </p>

                                    </mat-card-content>

                                </mat-card>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3" *ngIf="avisoUnidadesPallet">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeUnidadesPallet}} </p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                       
                            <div *ngIf="!isInRole('VENDEDOR')" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                                <mat-divider>
                                </mat-divider>
                            </div>

                            <div *ngIf="!isInRole('VENDEDOR')" class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div>
                            <div *ngIf="!isInRole('VENDEDOR')" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <mat-form-field color="accent-darker" appearance="outline">
                                    <mat-label>{{Etiquetas.CantidadComprada}}</mat-label>
                                    <input readonly appThreeDigitDecimaNumber formControlName="cantidadComprada"
                                        type="text" matInput>
                                    <mat-error
                                        *ngIf="!itemForm.controls['cantidadComprada'].valid && itemForm.get('cantidadComprada').touched">
                                        {{Validaciones.CantidadComprada}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        

                        <!--  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.DireccionEntrega}}</mat-label>
                                <input (change)="handleEmptyInputDirEntrega($event)" matInput
                                    [matAutocomplete]="autoDirEntrega" [formControl]="fcAutocompleteDirEntrega"
                                    placeholder="Nro.cliente, nombre, ciudad, calle y nro, etc..">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="Limpiar dir.entrega seleccionada" (click)="limpiarDirEntrega(true)">
                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoDirEntrega="matAutocomplete"
                                    (optionSelected)='seleccionarDirEntrega($event.option.value)'
                                    [displayWith]="getOptionTextDirEntrega">
                                    <mat-option *ngIf="loadingFcAutocompleteDirEntrega"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteDirEntrega">
                                        <mat-option *ngFor="let de of dirEntregasEncontradas" [value]="de">
                                            {{de.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroClienteDireccionEntrega}}</mat-label>

                                <input readonly formControlName="nroClienteDireccionEntrega" type="text" matInput>
                                <mat-error
                                    *ngIf="(itemForm.get('nroClienteDireccionEntrega').hasError('required')) && itemForm.get('nroClienteDireccionEntrega').touched">
                                    {{Validaciones.DireccionEntrega}}
                                </mat-error>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NombreClienteDireccionEntrega}}</mat-label>

                                <input readonly formControlName="nombreClienteDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CalleNroDireccionEntrega}}</mat-label>

                                <input readonly formControlName="calleNroDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CPDireccionEntrega}}</mat-label>

                                <input readonly formControlName="cpDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CiudadDireccionEntrega}}</mat-label>

                                <input readonly formControlName="ciudadDireccionEntrega" type="text" matInput>
                            </mat-form-field>
                        </div> -->

                        <div class="mat-toolbar-custom">
                            <mat-toolbar>
                                <mat-toolbar-row>

                                    <button mat-flat-button color="accent" (click)="nuevoItem()">
                                        <mat-icon>add</mat-icon>
                                        Nuevo ítem / Cargar ítem </button>

                                </mat-toolbar-row>

                            </mat-toolbar>

                        </div>

                    </div>
                    <div class="row align-items-center">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3 mt-3"
                            *ngIf="descuentosDiscrecionalesNegativos">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">
                                <H5>
                                    Aviso
                                </H5>

                                <mat-card-content>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                            {{Mensajes.DescuentosNegativos}}
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                            <ul *ngIf="itemsConDescuentoDiscrecionalNegativo.length">
                                                <li *ngFor="let item of itemsConDescuentoDiscrecionalNegativo">
                                                    {{ item.idProducto }} - {{ item.producto }}
                                                    ({{item.descuentoDiscrecional | number : '1.2-2'}} %)
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </mat-card-content>

                            </mat-card>
                        </div>

                    </div>

                    <div class="mat-table-pedidos">
                        <table mat-table [dataSource]="dataSourceItems" multiTemplateDataRows matSort
                            [hidden]="codigoEdit == 0" mat-table matTableResponsive mmatSortItems="matSort"
                            matSortActive="nroLinea" matSortDirection="asc">

                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef>{{Etiquetas.Acciones}}</th>
                                <td mat-cell *matCellDef="let pvi">
                                    <button *ngIf="cabForm.controls['idEstado'].value == 1 && alta"
                                        matTooltip="{{Tooltips.Editar}}" (click)="dialogItem(pvi)" mat-icon-button
                                        color="primary-darker">
                                        <mat-icon color="accent-darker">edit</mat-icon>
                                    </button>

                                    <button *ngIf="cabForm.controls['idEstado'].value == 1 && alta"
                                        (click)="eliminarItem(pvi)" matTooltip="{{Tooltips.Eliminar}}" mat-icon-button
                                        color="primary-darker">
                                        <mat-icon color="accent-darker">delete</mat-icon>
                                    </button>

                                </td>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="nroLinea">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.NroLinea}} </th>
                                <td mat-cell *matCellDef="let pvi">{{pvi.nroLinea}} </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>
                            <ng-container matColumnDef="fechaEntrega">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.FechaEntrega}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.fechaEntrega | date:'dd/MM/yyyy'}} </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>
                            <ng-container matColumnDef="idProducto">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.IdProducto}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.idProducto}} </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="producto">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Producto}} </th>
                                <td mat-cell *matCellDef="let pvi"> {{ pvi.producto }} </td>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                            <ng-container matColumnDef="cantidad">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.Cantidad}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.cantidad | number}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="itemDistribuidor">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.ItemDistribuidor}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    <div>
                                        <mat-icon color="accent-darker">{{ pvi.itemDistribuidor ?
                                            'check_box' :
                                            'check_box_outline_blank' }}
                                        </mat-icon>
                                    </div>
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>


                            <ng-container matColumnDef="itemPlanta">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.ItemPlanta}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    <div>
                                        <mat-icon color="accent-darker">{{ pvi.itemPlanta ?
                                            'check_box' :
                                            'check_box_outline_blank' }}
                                        </mat-icon>
                                    </div>
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>
                            <!-- 
                            <ng-container matColumnDef="precioKGL">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.PrecioKGL}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.precioKGL | number : '1.3-3'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container> -->


                            <ng-container matColumnDef="precioUnitarioLista">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.PrecioUnitarioLista}}

                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.precioUnitarioLista | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>



                            <ng-container matColumnDef="totalDescuento">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <!-- {{Etiquetas.TotalDescuento}} -->
                                    - Descuento
                                </th>
                                <!-- <td mat-footer-cell *matFooterCellDef> </td> -->
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.totalDescuento | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <!-- <ng-container matColumnDef="precioUnitarioFinal">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.PrecioUnitarioFinal}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.precioUnitarioFinal | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container> -->

                            <ng-container matColumnDef="recargo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <!-- {{Etiquetas.Recargo}} -->
                                    + Interés
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.recargo | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="totalPrecioKGL">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    <!-- {{Etiquetas.TotalPrecioKGL}} -->
                                    = Precio Final U.

                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.totalPrecioKGL | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> Total </td>
                            </ng-container>

                            <ng-container matColumnDef="total">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.Total}}
                                </th>
                                <td mat-cell *matCellDef="let pvi">
                                    {{pvi.total | number : '1.2-2'}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> {{totalItems | number : '1.2-2'}} </td>
                            </ng-container>


                            <ng-container matColumnDef="expand">
                                <th mat-header-cell *matHeaderCellDef aria-label="row actions">{{Etiquetas.Descuentos}}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button aria-label="expand row"
                                        (click)="toggleExpandRow(element); $event.stopPropagation()">
                                        <mat-icon
                                            *ngIf="expandedElement !== element">keyboard_double_arrow_down</mat-icon>
                                        <mat-icon
                                            *ngIf="expandedElement === element">keyboard_double_arrow_up</mat-icon>
                                    </button>
                                </td>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>

                            <ng-container matColumnDef="expandedDetail">
                                <div>
                                    <td mat-cell *matCellDef="let element"
                                        [attr.colspan]="columnsToDisplayWithExpand.length">
                                        <div class="example-element-detail"
                                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">


                                            <table [hidden]="codigoEdit == 0" mat-table matTableResponsive
                                                [dataSource]="dataSourceItemsDescuentosFiltrados" matSort
                                                #matSortItemsDescuentos="matSort" matSortActive="idTipoCondicion"
                                                matSortDirection="asc">

                                                <ng-container matColumnDef="idTipoCondicion">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{Etiquetas.IdTipoCondicion}}
                                                    </th>
                                                    <td mat-cell *matCellDef="let desc">
                                                        {{desc.idTipoCondicion}}
                                                    </td>
                                                    <td mat-footer-cell *matFooterCellDef> </td>
                                                </ng-container>

                                                <ng-container matColumnDef="tipoCondicion">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{Etiquetas.DescripcionItemDescuento}}
                                                    </th>
                                                    <td mat-cell *matCellDef="let desc">
                                                        {{desc.tipoCondicion}}
                                                    </td>

                                                    <td mat-footer-cell *matFooterCellDef> </td>
                                                </ng-container>


                                                <ng-container matColumnDef="importe">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{Etiquetas.Importe}}
                                                    </th>
                                                    <td mat-cell *matCellDef="let desc">
                                                        <div [hidden]="!desc.totalTr">

                                                        </div>
                                                        <div [hidden]="desc.totalTr">
                                                            {{desc.importe | number : '1.2-2'}}

                                                        </div>
                                                    </td>
                                                    <td mat-footer-cell *matFooterCellDef> </td>
                                                </ng-container>

                                                <ng-container matColumnDef="porcentaje">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{Etiquetas.Porcentaje}}
                                                    </th>
                                                    <td mat-cell *matCellDef="let desc">
                                                        <div style="font-weight: bold;" [hidden]="!desc.totalTr">
                                                            Total
                                                        </div>
                                                        <div [hidden]="desc.totalTr">
                                                            {{desc.porcentaje | number : '1.2-2'}}

                                                        </div>
                                                    </td>
                                                    <td mat-footer-cell *matFooterCellDef>Total Descuentos</td>
                                                </ng-container>

                                                <ng-container matColumnDef="descuento">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{Etiquetas.Descuento}}
                                                    </th>
                                                    <td mat-cell *matCellDef="let desc">
                                                        <div style="font-weight: bold;" [hidden]="!desc.totalTr">
                                                            {{desc.descuento | number : '1.2-2'}}
                                                        </div>
                                                        <div [hidden]="desc.totalTr">
                                                            {{desc.descuento | number : '1.2-2'}}
                                                        </div>
                                                    </td>
                                                    <td mat-footer-cell *matFooterCellDef> {{totalDesc | number :
                                                        '1.2-2'}}</td>
                                                </ng-container>


                                                <tr mat-header-row *matHeaderRowDef="displayedColumnsItemsDescuentos">
                                                </tr>
                                                <tr mat-row
                                                    *matRowDef="let desc; columns: displayedColumnsItemsDescuentos;"
                                                    [ngStyle]="{'background': desc.totalTr ? '#d5ffd5' : '' }">
                                                </tr>
                                                <tr mat-footer-row *matFooterRowDef="displayedColumnsItemsDescuentos"
                                                    [ngStyle]="{'background': '#d5ffd5 !important'}"></tr>

                                            </table>


                                        </div>
                                    </td>
                                </div>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsItems"></tr>

                            <tr mat-row *matRowDef="let element; columns: displayedColumnsItems;"
                                class="example-element-row" [class.example-expanded-row]="expandedElement === element"
                                (click)="toggleExpandRow(element); $event.stopPropagation()">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: "
                                class="example-detail-row">
                            </tr>

                            <tr mat-footer-row *matFooterRowDef="displayedColumnsItems"></tr>
                            <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                <td class="mat-cell" [attr.colspan]="displayedColumnsItems.length">
                                    {{Etiquetas.SinRegistros}}
                                </td>
                            </tr>

                        </table>

                    </div>
                </div>
            </form>
            <!-- </div> -->
        </mat-expansion-panel>

        <!-- <mat-expansion-panel *ngIf="dataSourceItems.data.length" [expanded]="true">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Ítems descuento
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="container-fluid mt-4">


        <div class="mat-table-pedidos">
            <table [hidden]="codigoEdit == 0" mat-table matTableResponsive [dataSource]="dataSourceItemsDescuentos"
                matSort #matSortItemsDescuentos="matSort" matSortActive="nroLinea" matSortDirection="asc">


                <ng-container matColumnDef="idProducto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.IdProducto}}
                    </th>
                    <td mat-cell *matCellDef="let desc">
                        {{desc.idProducto}} </td>
                </ng-container>

                <ng-container matColumnDef="producto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{Etiquetas.Producto}}
                    </th>
                    <td mat-cell *matCellDef="let desc">
                        {{desc.producto}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="idTipoCondicion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{Etiquetas.IdTipoCondicion}}
                    </th>
                    <td mat-cell *matCellDef="let desc">
                        {{desc.idTipoCondicion}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="tipoCondicion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{Etiquetas.DescripcionItemDescuento}}
                    </th>
                    <td mat-cell *matCellDef="let desc">
                        {{desc.tipoCondicion}}
                    </td>
                </ng-container>


                <ng-container matColumnDef="importe">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{Etiquetas.Importe}}
                    </th>
                    <td mat-cell *matCellDef="let desc">
                        <div [hidden]="!desc.totalTr">

                        </div>
                        <div [hidden]="desc.totalTr">
                            {{desc.importe | number : '1.2-2'}}

                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="porcentaje">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{Etiquetas.Porcentaje}}
                    </th>
                    <td mat-cell *matCellDef="let desc">
                        <div style="font-weight: bold;" [hidden]="!desc.totalTr">
                            Total
                        </div>
                        <div [hidden]="desc.totalTr">
                            {{desc.porcentaje | number : '1.2-2'}}

                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="descuento">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{Etiquetas.Descuento}}
                    </th>
                    <td mat-cell *matCellDef="let desc">
                        <div style="font-weight: bold;" [hidden]="!desc.totalTr">
                            {{desc.descuento | number : '1.2-2'}}
                        </div>
                        <div [hidden]="desc.totalTr">
                            {{desc.descuento | number : '1.2-2'}}
                        </div>
                    </td>
                </ng-container>



                <tr mat-header-row *matHeaderRowDef="displayedColumnsItemsDescuentos"></tr>
                <tr mat-row *matRowDef="let desc; columns: displayedColumnsItemsDescuentos;"
                    [ngStyle]="{'background': desc.totalTr ? '#d5ffd5' : '' }">s

                </tr>


                <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="displayedColumnsItemsDescuentos.length">
                        {{Etiquetas.SinRegistros}}
                    </td>
                </tr>
            </table>

            <mat-paginator #matPaginatorItemsDescuentos="matPaginator" [pageSizeOptions]="[25, 50, 100]"
                showFirstLastButtons>
            </mat-paginator>
        </div>

    </div>

</mat-expansion-panel> -->


    </mat-accordion>
</div>
<div class="mat-toolbar-custom">
    <mat-toolbar>
        <mat-toolbar-row>

            <button mat-flat-button color="accent" (click)="guardar()"
                *ngIf="cabForm.controls['idEstado'].value == 1 && alta">
                <mat-icon>add</mat-icon>
                Guardar</button>

            <button *ngIf="codigoEdit != 0 && cabForm.controls['idEstado'].value != 1 " mat-flat-button color="accent"
                (click)="dialogLogAutorizaciones()">
                <mat-icon>search</mat-icon>
                Workflow</button>
            <button
                *ngIf="isInRole('VENDEDOR') && (cabForm.controls['idEstado'].value == 2 || cabForm.controls['idEstado'].value == 3 || cabForm.controls['idEstado'].value == 5)"
                mat-flat-button color="accent" (click)="dialogNroOC()">
                <mat-icon>edit</mat-icon>
                Ingresar Nro. OC </button>

            <button *ngIf="retenciones?.length > 0 && 
            ((codigoEdit != 0 && cabForm.controls['idEstado'].value != 1) || cabForm.controls['idEstado'].value != 1)"
                mat-flat-button color="warn" (click)="dialogRetenciones()">
                <mat-icon>search</mat-icon>
                Motivos Retención</button>

            <button
                *ngIf="cabForm.controls['rechazar'].value == true && cabForm.controls['idEstado'].value != 1 && cabForm.controls['idEstado'].value != 6 && cabForm.controls['idEstado'].value != 4"
                mat-flat-button color="warn" (click)="dialogComentario(2,true)">
                <mat-icon>front_hand</mat-icon>
                Rechazar cotización</button>

            <button
                *ngIf="dataSourceItems.data.length && cabForm.controls['aprobar'].value == true && cabForm.controls['idEstado'].value != 3 && cabForm.controls['idEstado'].value != 5 && cabForm.controls['idEstado'].value != 4"
                mat-flat-button color="primary" (click)="dialogComentario(1,false)">
                <mat-icon>thumb_up</mat-icon>
                Aprobar</button>

            <button
                *ngIf="dataSourceItems.data.length && cabForm.controls['aprobar'].value == true && cabForm.controls['idEstado'].value == 3 && (isInRole('ADM') || isInRole('ADMVENTAS') || isInRole('COBRANZAS/CTAS.CTES') || isInRole('CREDITOS') )"
                mat-flat-button color="primary" (click)="dialogAprobacionRetenido()">
                <mat-icon>thumb_up</mat-icon>
                Aprobar</button>

            <!-- me aseguro que no aparezca el boton rechazar para los adm, solo el de rechazar cotizacion  -->
            <button
                *ngIf="(!isInRole('ADM') || !isInRole('ADMVENTAS') || !isInRole('ADM LOCAL')) && cabForm.controls['aprobar'].value == true && (cabForm.controls['idEstado'].value == 2 || cabForm.controls['idEstado'].value == 3)"
                mat-flat-button color="warn" (click)="dialogComentario(5,true)">
                <mat-icon>thumb_down</mat-icon>
                Rechazar</button> <!--los adm no , solo para estados pendiente y retenido -->

            <button
                *ngIf="dataSourceItems.data.length && cabForm.controls['aprobar'].value == true && cabForm.controls['idEstado'].value == 5 && (isInRole('ADM') || isInRole('ADMVENTAS') || isInRole('COBRANZAS/CTAS.CTES') || isInRole('CREDITOS'))"
                mat-flat-button color="primary" (click)="dialogComentario(4,false)">
                <mat-icon>thumb_up</mat-icon>
                Aprobar Cotización</button>
            <!-- el aprobar cotizacion es por las dudas si el cliente no puede aprobar con el mail -->

            <!-- generar PDF poner para estados pendiente confirmacion cliente y aprobadacliente -->
            <button
                *ngIf="(isInRole('ADM') || isInRole('ADMVENTAS')) && (cabForm.controls['idEstado'].value == 4 || cabForm.controls['idEstado'].value == 5)"
                mat-flat-button color="primary" (click)="pruebaMailCot()">
                <mat-icon>picture_as_pdf</mat-icon>
                Reenvío PDF</button>

            <span class="mat-toolbar-row-separador"></span>
            <button mat-flat-button color="accent" (click)="regresarALaRutaAnterior()">
                <mat-icon>arrow_left</mat-icon>
                Volver al buscador</button>

        </mat-toolbar-row>
    </mat-toolbar>

</div>